import { Diagnostic } from '../models/Student';

export const getLastestDiagnostic = (diagnostics: Diagnostic[]) => {
  if (diagnostics.length) {
    let latest = diagnostics[0];
    diagnostics.forEach(diagnostic => {
      if (new Date(diagnostic.sessionCompletedOn).getTime() > new Date(latest.sessionCompletedOn).getTime()) {
        latest = diagnostic;
      }
    });
    return latest;
  }
  return null;
};
